// API Base URL configuration

/**
 * Determines if the application is running in production mode
 * @returns true if VITE_IS_PRODUCTION is 'true', false otherwise
 */
export const getIsProduction = (): boolean => {
  return import.meta.env.VITE_IS_PRODUCTION === 'true';
};

/**
 * Gets the API base URL based on the current environment (DEV or PROD)
 * @returns The base URL for the current environment
 */
export const API_BASE_URL = getIsProduction()
  ? import.meta.env.VITE_API_BASE_URL_PROD
  : import.meta.env.VITE_API_BASE_URL_DEV;

/**
 * Builds a full API URL from an endpoint path
 * @param endpoint - The API endpoint path (e.g., '/api/overview/123')
 * @returns Full URL combining base URL with endpoint
 */
export const getApiUrl = (endpoint: string): string => {
  // Ensure endpoint starts with /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  // If API_BASE_URL is empty or not a full URL, use window.location.origin as fallback
  const baseUrl = API_BASE_URL && (API_BASE_URL.startsWith('http://') || API_BASE_URL.startsWith('https://'))
    ? API_BASE_URL
    : typeof window !== 'undefined' 
      ? window.location.origin 
      : '';
  
  return `${baseUrl}${normalizedEndpoint}`;
};

